/**
 * Feel free to write your ES6 code here, it will
 * be transpiled automatically.
 */

document.addEventListener( 'DOMContentLoaded', function() {
	const form = document.querySelector( '.eminova-bankid-initial-form' );
	const wrapper = document.querySelector( '.eminova-bankid-login-wrapper' );

	if ( form && wrapper ) {
		form.addEventListener( 'submit', function( e ) {
			e.preventDefault();
			wrapper.classList.add( 'show-bankid' );
		} );
	}
} );
